
<script>
import BrandService from '@/store/services/brand.service.js'
import ArchiveBase from '@/components/base_components/ArchiveBase.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'BrandArchive',
  extends: ArchiveBase,
  computed: {
    ...mapGetters({
      currentCompany: 'main/getCurrentCompany',
    }),
  },
  methods: {
    ...mapActions({
      loadCompanyBrands: 'brands/loadCompanyBrands',
    }),
    extendable() {
      this.swapState()

      BrandService.archive(this.item.id)
        .then(() => {
          this.loadCompanyBrands(this.currentCompany.id)
        })
        .catch((error) => {
          this.swapState()

          if (error.status === 400) {
            this.$store.commit('setAlert', {
              title: this.$gettext('Cannot archive brand'),
              text: error.data.detail,
              variant: 'danger',
              duration: 4,
            })
          } else if (error.status === 403) {
            this.$store.commit('togglePremiumModal', 'web_brands')
          } else {
            this.$store.commit('setAlert', {
              title: this.$gettext('Error'),
              text: this.$gettext('Something went wrong, brand is not archived.'),
              variant: 'danger',
              duration: 4,
            })
          }
        })
    },
  },
}
</script>